const $projects = document.querySelector('#projects')

if (window.innerWidth > 600) {
  const flipCards = () => {
    document.querySelectorAll('.projects__card').forEach((card, i) => {
      setTimeout(() => {
        card.classList.add('flip')
      }, 500 * i)
    })
  }

  const fn = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // console.log(entry)
        // console.log(entry.target, 'is intersecting!!~~~~~')
        flipCards()
      }
    })
  }

  const options = { threshold: 0.6 }

  const observer = new IntersectionObserver(fn, options)

  observer.observe($projects)
} else {
  const $projectCards = document.querySelectorAll('.projects__card')
  const flipCard = element => {
    element.classList.add('flip')
    // $projectCards.forEach((card, i) => {
    //   // setTimeout(() => {
    //   // }, 500 * i)
    // })
  }

  const fn = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // console.log(entry)
        // console.log(entry.target, 'is intersecting!!~~~~~')
        flipCard(entry.target)
      }
    })
  }

  const options = { threshold: 0.6 }

  const observer = new IntersectionObserver(fn, options)

  $projectCards.forEach(card => {
    observer.observe(card)
  })
}

// console.log(window.innerWidth)

window.addEventListener('resize', () => {
  // console.log(window.innerWidth)
  if (window.innerWidth > 600) {
    const flipCards = () => {
      document.querySelectorAll('.projects__card').forEach((card, i) => {
        setTimeout(() => {
          card.classList.add('flip')
        }, 500 * i)
      })
    }

    const fn = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // console.log(entry)
          // console.log(entry.target, 'is intersecting!!~~~~~')
          flipCards()
        }
      })
    }

    const options = { threshold: 0.6 }

    const observer = new IntersectionObserver(fn, options)

    observer.observe($projects)
  } else {
    const $projectCards = document.querySelectorAll('.projects__card')
    const flipCard = element => {
      element.classList.add('flip')
      // $projectCards.forEach((card, i) => {
      //   // setTimeout(() => {
      //   // }, 500 * i)
      // })
    }

    const fn = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // console.log(entry)
          // console.log(entry.target, 'is intersecting!!~~~~~')
          flipCard(entry.target)
        }
      })
    }

    const options = { threshold: 0.6 }

    const observer = new IntersectionObserver(fn, options)

    $projectCards.forEach(card => {
      observer.observe(card)
    })
  }
})
